/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { get } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from '../Definitions';

const definitions = Definitions.Countries;

const callGet = async (params?: {
  country?: string;
  iso2?: string;
  iso3?: string;
  ddi?: string;
}): Promise<IFinalResponse> => {
  const init: InitApiType = {};

  if (params) {
    init.params = {};

    if (params.country) init.params.country = params.country;
    if (params.iso2) init.params.iso2 = params.iso2;
    if (params.iso3) init.params.iso3 = params.iso3;
    if (params.ddi) init.params.ddi = params.ddi;
  }

  return get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};

const call = { get: callGet };

export default { call, definitions };
